import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/iconfont/iconfont.css'
import router from './router'
import { Lazyload } from 'vant';
import less from 'less'
Vue.use(Lazyload);
Vue.use(less)
import store from './store'//引入store

import FastClick from 'fastclick'
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (/iphone|ipod|ipad/i.test(navigator.appVersion) &&targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
}
FastClick.attach(document.body) //  hack the active pseudo-classes failure caused by -webkit-overflow-scrolling touch

Vue.use(Vant);

Vue.config.productionTip = false

Vue.config.ignoredElements = ['wx-open-launch-weapp'];
//远程加载js的方式
Vue.component('remote-script', {
    render: function (createElement) {
        var self = this;
        return createElement('script', {
            attrs: {
                type: 'text/javascript',
                src: this.src
            },
            on: {
                load: function (event) {
                    self.$emit('load', event);
                },
                error: function (event) {
                    self.$emit('error', event);
                },
                readystatechange: function (event) {
                    if (this.readyState == 'complete') {
                        self.$emit('load', event);
                    }
                }
            }
        });
    },
    props: {
        src: {
            type: String,
            required: true
        }
    }
});

new Vue({
  router,
  store,
  render: h => h(App),
    data: {
        eventHub: new Vue() //的空vue对象。就可以使用 this.$root.eventHub 获取对象。 / bus接收事件
    }

}).$mount('#app')
